import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { AnchorWithEvent, Anchor } from "hesus-ui-kit";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import AddEditContact from "../../../../Contact/AddEditContact";
import { LeadIdContainer, GrayPara, TextInfo } from "../../LeadList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../LeadList.scss";

const LeadInfo = (props) => {
  const { t, data, column } = props;

  const history = useNavigate();
  const [contactData, setContactData] = useState([]);
  const [isEditContactPopupVisible, setIsEditContactPopupVisible] =
    useState(false);

  const closeContactEditPopup = () => {
    setIsEditContactPopupVisible(false);
  };

  const showConntactPopUp = (id) => {
    axios
      .get(`/contacts/${id}`)
      .then((response) => {
        setContactData(response.data[0]);
        setIsEditContactPopupVisible(true);
      })
      .catch((error) => {});
  };

  return (
    <>
      <DivBackgroundOpacity>
        <LeadIdContainer>
          {column === "id" && (
            <Link
              to={`/lead/view/${data}`}
              className="leads-list__id-link"
            >
              {"#" + data}
            </Link>
          )}
          {column === "date" && data}
        </LeadIdContainer>
        {column === "contact" && (
          <>
            <LeadIdContainer>
              {data.companyId && (
                <AnchorWithEvent
                  clickAction={() => showConntactPopUp(data.contact?.id)}
                  className="leads-list__id-link"
                >
                  {"#" + data.contact?.id + " - " + data.contact?.name}
                </AnchorWithEvent>
              )}

              {!data.companyId && (
                <TextInfo className="leads-list__link">
                  {data.contact?.name}
                </TextInfo>
              )}
            </LeadIdContainer>
            <GrayPara>{data.companyname} </GrayPara>
          </>
        )}
        {column === "site" && (
          <>
            {data?.site?.id && (
              <LeadIdContainer>
                <Anchor
                  url={`/site/view/${data?.site?.id}/general-info`}
                  className="leads-list__id-link"
                  target="_blank"
                >
                  {"#" + data.site.id + " - " + data.site.name}
                </Anchor>
              </LeadIdContainer>
            )}
            {!data?.site?.id && (
              <LeadIdContainer>
                <TextInfo className="leads-list__link">
                  {data.address.city + " (" + data.address.postalCode + ")"}
                </TextInfo>
              </LeadIdContainer>
            )}

            {data.enquiry?.[0]?.id && (
              <GrayPara>
                {data.enquiry?.[0]?.quantity +
                  " " +
                  t(data.enquiry?.[0]?.unit) +
                  " - " +
                  t(data.enquiry?.[0]?.subCategory?.name)}
              </GrayPara>
            )}

            {data.totalEnquiries > 1 && (
              <GrayPara color="#474747" fontWeight="700" fontSize="14px">
                {"+" + (data.totalEnquiries - 1) + " " + t("ENQUIRIES")}
              </GrayPara>
            )}
          </>
        )}
      </DivBackgroundOpacity>
      {isEditContactPopupVisible && (
        <AddEditContact
          id={contactData?.contactId}
          title={t("CONTACT") + " #" + contactData?.id}
          onClose={closeContactEditPopup}
          isViewMode
          isViewContact
          contactData={contactData}
          updateRefeshStatus={null}
        />
      )}
    </>
  );
};

LeadInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LeadInfo);
